export default {
  browse:{
    table:{
      headers: [
        {
          text: 'No.',
          value: 'index',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Participant',
          value: 'Participant',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Checkpoint',
          value: 'Checkpoint',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Top Star',
          value: 'topStar',
        },
        {
          text: 'Top Score',
          value: 'topScore',
        },
        {
          text: 'Attempt',
          value: 'attempt',
        },
      ],
    },
  },
  read:{
    tabs:[
      {
        key:'Info',
        label:'info',
      },
    ],
    table:{
      headers: [
        {
          text: 'Created',
          value: 'timestampCreated',
          filterable: false,
        },
        {
          text: 'Last Updated',
          value: 'timestampUpdated',
          filterable: false,
        },
      ],
    },
  },
  add:false,
  edit:false,
  delete:true,
}